export default {
  id: '12',
  email: 'person@overteam.ru',
  first_name: 'test',
  last_name: 'test',
  middle_name: 'test',
  role: 'admin',
  authentication_token: '12',
};
